<template>
    <section class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-header">
                            <h3 class="card-title">{{ $t('your_films') }}</h3>
                        </div>
                        <!-- /.card-header -->
                        <div class="card-body table-responsive p-0">
                            <table class="table table-hover">
                                <thead>
                                <tr>
                                    <th>{{ $t('title_international') }}</th>
                                    <th>{{ $t('original_title') }}</th>
                                    <th>{{ $t('edit_films') }}</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="movie in movies.data" :key="movie.id">
                                    <td>{{ movie.title_international }}</td>
                                    <td>{{ movie.title_original }}</td>
                                    <td>
                                        <a href="#" @click="goToMovie(movie.id)">
                                            <i class="fa fa-edit blue"></i>
                                        </a>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <!-- /.card-body -->
                        <div class="card-footer">
                            <pagination :data="movies" @pagination-change-page="getResults"></pagination>
                        </div>
                    </div>
                    <!-- /.card -->
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import movies from "../services/api/movies";

export default {
    name: "MoviesList",
    data() {
        return {
            movies: {},
        }
    },
    methods: {
        getResults(page = 1) {
            this.$Progress.start();
            let queryString = new URLSearchParams({page: page})
            movies.index(queryString).then(({data}) => (this.movies = data.data));
            this.$Progress.finish();
        },
        loadMovies() {
            movies.index().then(({data}) => (this.movies = data.data));
        },
        goToNewMovie() {
            this.$router.push('movie')
        },
        goToMovie(movieId) {
            this.$router.push('movie/' + movieId)
        },
    },
    created() {
        this.$Progress.start();
        this.loadMovies();
        this.residenceCertificateUploadUrl = window.baseUrl + '/residence-certificate'
        axios.get("/api/v1/rights-owners/profile")
            .then((response) => {
                this.hasCertificate = response.data.data.hasCertificateCurrentYear
            });
        this.$Progress.finish();
    },
}
</script>

<style scoped>
</style>
